<template>
<div>
    <navbar/>
    <div class="container-fluid">
            <h3>Detalle del caso</h3>
            <button @click="actualizar">Actualizar</button>
            <router-link style="float: right" :to="{ name: 'notas', params: { id: this.$route.params.id, tipo: 'casos' }}" class="linkRefnum">Notas </router-link>
            <router-link style="float: right" :to="{ name: 'archivos', params: { id: this.$route.params.id, tipo: 'casos' }}" class="linkRefnum">Archivos | </router-link>
            <div class="row">
                <div class="col-md-6 ">
                    Contacto: 
                    <select class="form-control" v-model="oneCaso.idcontacto" @change="selectContacto(oneCaso.idcontacto)">
                        <option v-for="item in allContacto" :key="item.id" :value="item.id">{{item.nombre}}</option>
                    </select>
                </div>
                <div class="col-md-6 ">
                    Producto: 
                    <select class="form-control" v-model="oneCaso.idproducto" @change="selectProducto(oneCaso.idproducto)">
                        <option v-for="item in allProductos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 ">
                    Motivo: 
                    <select class="form-control" v-model="oneCaso.idtipo" @change="selectMotivo(oneCaso.idtipo)">
                        <option v-for="item in allMotivos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                    </select>
                </div>
                <div class="col-md-6 ">
                    subMotivo: 
                    <select class="form-control" v-model="oneCaso.idsubtipo">
                        <option v-for="item in allSubMotivos" :key="item.id" :value="item.id">{{item.nombres}}</option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 ">
                     Prioridad: 
                    <select class="form-control" v-model="oneCaso.idprioridad">
                        <option v-for="item in allPrioridades" :key="item.id" :value="item.id">{{item.nivel}}</option>
                    </select>
                </div>
                <div class="col-md-6 ">
                    Estado: 
                    <select class="form-control" v-model="oneCaso.idestado">
                        <option v-for="item in allEstados" :key="item.id" :value="item.id">{{item.descripcion}}</option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 ">
                     Cuenta: 
                    <select class="form-control"  v-model="oneCaso.idcuenta">
                        <option v-for="item in allCuentas" :key="item.id" :value="item.id">{{item.identificador}} - {{item.razonsocial}}</option>
                    </select>
                </div>
                <div class="col-md-6 ">
                    Proceso: 
             
                    <select class="form-control"  v-model="oneCaso.idworkflow">
                        <option v-for="item in allProcesos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                    </select>
                </div>
             </div>

             <div class="row">
                <div class="col-md-6 ">
                    Paso: 
             
                    <select class="form-control"  v-model="oneCaso.idstageactual">
                        <option v-for="item in allStages" :key="item.id" :value="item.id">{{item.nombre}}</option>
                    </select>
                </div>
                <div class="col-md-6 ">
                     Usuario Asignado: 
                      <select class="form-control"  v-model="oneCaso.idusuarioasignado">
                        <option v-for="item in userDisponibles" :key="item.id" :value="item.id">{{item.nombre}}</option>
                    </select>
                </div>
             </div>

            <div class="row">
              <div class="col-md-12 ">
                     Asunto: 
                    <textarea class="form-control" v-model="oneCaso.asunto"></textarea>
                </div>
             </div>

             <div class="row">
                <div class="col-md-12 ">
                    Campos Personalizados:
                    <div v-for="cf  in allCfs" :key="cf.id">
                        <p>{{cf.nombre}}</p>
                        <input class="form-control" v-model="createCampos[cf.nombre]">
                    </div>
                </div>
             </div>     
        <div>
            checklist
            <div class="row">
            <form>
                <div :xs="24" v-for="tarea in allCheck" :key="tarea.id" class="check col-md-12">
                    <div :label="tarea.label" >
                        <input type="checkbox" checked="checked" :id="String(tarea.id)" v-model="tarea.estadocaso" :true-label="1" :indeterminate="tarea.tipo === 4 ? isIndeterminate : false" :disabled="tarea.tipo === 4 ? disabled : false" :false-label="0" @change="checkCmb({ idcaso: String(tarea.id), objeto: tarea, value: $event})" :fill="tarea.tipo === 4 ? colorCheck : ''" />
                            {{ tarea.descripcion }}
                        <span v-if="tarea.estadoaprobacion === 0 && tarea.comentario !== null" style="color:#c32905;font-size: 12px;"> {{ '[ ' + tarea.comentario + ' ]' }}</span>
                        <span class="btnHabilitarCheck" v-if="tarea.estadoaprobacion === 0 && tarea.comentario !== null" @click="habilitarCheck(tarea)">Habilitar</span>
                        <span class="btnHabilitarCheck" v-if="tarea.estadoaprobacion === 3 && tarea.urlexpiracion === 1" @click="habilitarCheck(tarea)">Habilitar</span>
      
                    </div>
                </div>
            </form>
        </div>
        </div>
        <button @click="next">next</button>
        <button @click="back">back</button> 
        </div> 
</div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    components:{
        navbar: () => import('@/views/Agente/navBar.vue'),
        nota: () => import('@/views/Agente/Notas')
    },
    data(){
        return{
            cfs: {},
            modalContainerVisible: false,
            htmlToRender: ``,
            titulo: '',
            classObject: {
                active: true,
                'text-danger': false
            },
            actualCheck: '',
            showButton: false,
            isExternal: false,
            url: '',
            disabled: false,
            isIndeterminate: false,
            colorCheck: ''
        }
    },
    computed:{
        //subtipó
        ...mapGetters('validatetoken', { oneCaso: 'oneCaso',
            allContacto: 'allContacto',
            allProductos: 'allProductos',
            allMotivos: 'allMotivos',
            allSubMotivos: 'allSubMotivos',
            allPrioridades: 'allPrioridades',
            allEstados: 'allEstados',
            allCuentas: 'allCuentas',
            allProcesos: 'allProcesos',
            allCfs: 'allCfs',
            allStages: 'allStages',
            userDisponibles: 'userDisponibles',
            allCheck: 'allCheck'
        }),
        idCaso(){
            return {
                id: this.$route.params.id
            } 
        },
        createCampos:{
             get() {
                if (this.oneCaso.cf === undefined || this.oneCaso.cf === null) {
                    return {}
                }
                Object.keys(this.oneCaso.cf).forEach(key => {
                    if (this.oneCaso.cf[key] === '') {
                        this.oneCaso.cf[key] = null
                        // delete this.value[key]
                    }
                })
                return this.oneCaso.cf
            },
            set(data){
                this.$emit('input', data)
            }
        },
       
        idCuentaForCase(){
            return {
                idcuenta: 0 // es para traer las cuentas asociadas al contacto
            }
        }
    },
    methods:{
        ...mapActions('validatetoken', { getBy: 'getBy',
            save: 'save', add: 'add',
            getContacto: 'getContacto',
            getAllProductos: 'getAllProductos',
            getAllMotivos: 'getAllMotivos',
            getAllSubMotivos: 'getAllSubMotivos',
            getPrioridades: 'getPrioridades',
            getAllEstados: 'getAllEstados',
            getAllCuentas: 'getAllCuentas',
            getAllProcesos: 'getAllProcesos',
            getAllCfs: 'getAllCfs',
            nextCase: 'nextCase',
            backCase: 'backCase',
            getAllCheck: 'getAllCheck',
            check: 'check',
            scriptEjecute: 'scriptEjecute'

            //proceso
        }),
        getAll(){
            let data = {}

            data = {
                id: this.$route.params.id,
                method: ['cfs', 'prioridades', 'estados', 'checklist', 'contactos','tipificacion','procesos','cuentas', 'pasos', 'usuarios']
            //  method: ['cfs', 'prioridades', 'estados', 'checklist', 'contactos','tipificacion','procesos','cuentas', 'pasos', 'usuarios']
            }
            
            Promise.all([
                this.getBy(data),
                // this.getPrioridades(),
                // this.getAllEstados(),
                // this.getAllCfs({ idtipoobjeto: 1 }),
                // this.getAllCheck({
                    //     idcaso: this.$route.params.id
                // }),


                // this.getAllProcesos({
                //     activo: 1,
                //     cantidad: 10,
                //     pagina: 1
                // }),
                // this.getContacto(this.idCuentaForCase)
                // .then((data)=>{
                //     this.$store.commit('validatetoken/setAllContacto', data)
                // }),
                // this.getAllCuentas({
                //     cantidad: 10,
                //     pagina: 1
                // })
            ])
        },
        
        actualizar(){
            this.oneCaso.cf = this.oneCaso.cf
            this.save(this.oneCaso)
            .then(()=>{
                this.getAll()
            })
        },
        agregar(){
            this.add(this.Case)
        },
        selectContacto(id){
            let query = {
                idcontacto: id
            }

            Promise.all([
                this.getAllCuentas({...query,
                    cantidad: 10,
                    pagina: 1
                }),
                this.getAllProductos(query)
            ])

        },
        selectProducto(id){
            let query = {
                idproducto: id,
                idcontacto: this.oneCaso.idcontacto
            }
           
             this.getAllMotivos(query)
        },
        selectMotivo(id){
            let query = {
                idtipo: id,
                idproducto: this.oneCaso.idtipo,
                idcontacto: this.oneCaso.idcontacto
            }
            this.getAllSubMotivos(query)
        },
        next(){
            let data = {
                id: this.$route.params.id
            }
            this.nextCase(data)
        },
        back(){
             let data = {
                id: this.$route.params.id
            }
            this.backCase(data)
        },
        checkCmb(entrada) {
                if (entrada.objeto.tipo === 0 || entrada.objeto.idtipo === null) {
                    this.check({ idcaso: entrada.idcaso, idtarea: entrada.objeto.id, value: entrada.value.target.checked, origin: window.location.hostname })
                } else if (entrada.objeto.tipo === 1) {
                    this.isExternal = true
                    if (entrada.objeto.estadocaso === 1) {
                        this.url = entrada.objeto.script
                        this.showButton = false
                        this.modalContainerVisible = true
                    }
                    this.check({ idcaso: entrada.idcaso, idtarea: entrada.objeto.id, value: entrada.value.target.checked, origin: window.location.hostname })
                } else if(entrada.objeto.tipo === 3) {
                    if (entrada.objeto.estadocaso === 1) {
               
                        this.scriptEjecute({ idscript: entrada.objeto.idtipo, idcaso: Number(entrada.idcaso) } )
                        .then((data) => {
                            this.$notify({
                                //title: this.$t('checklist.message'),
                                message: data.message,
                                type: 'success',
                                customClass: 'notifyItg'
                            })
                         
                            this.check({ idcaso: entrada.idcaso, idtarea: entrada.objeto.id, value: entrada.value.target.checked, origin: window.location.hostname })
                        }).catch((error) => {
                            this.$notify({
                                //title: this.$t('checklist.error'),
                                message: error.response.data.message,
                                type: 'error',
                                customClass: 'notifyItg'
                            })
                            // this.$notification('error', error.response.data.message)
                            entrada.objeto.estadocaso = false
                        })
                    } else {
                        this.check({ idcaso: entrada.idcaso, idtarea: entrada.objeto.id, value: entrada.value.target.checked, origin: window.location.hostname })
                    }
            } 
            else if (entrada.objeto.tipo === 4) {
                    this.check({ idcaso: entrada.idcaso, idtarea: entrada.objeto.id, value: entrada.value.target.checked, origin: window.location.hostname })
                        .then((data) => {
                          if (data.estadoaprobacion === 3) {
                              entrada.objeto.estadocaso = false
                              this.disabled = true
                          }
                        })
                    //this.isIndeterminate = true
                }else if (entrada.objeto.tipo === 5) {
                    this.check({ idcaso: entrada.idcaso, idtarea: entrada.objeto.id, value: entrada.value.target.checked, origin: window.location.hostname })
                    if (entrada.objeto.estadocaso === 1) {
                        // this.$swal({
                        //     type: 'success',
                        //     title: this.$t('ActionListSurvey.title'),
                        //     html: this.$t('ActionListSurvey.msgHtml'),
                        //     showCloseButton: true,
                        //     showCancelButton: false,
                        //     focusConfirm: false
                        // })
                    }
                }else if (entrada.objeto.tipo === 2) {
                    this.isExternal = false
                    if (entrada.objeto.estadocaso === 1) {
                        var content = this.parsedContent(entrada.objeto.script)
                       //this.titulo = this.$t('customForm')
                        this.htmlToRender = '<form id="customFormID" class="customFormID">'
                        this.htmlToRender = this.htmlToRender + content
                        // this.htmlToRender = this.htmlToRender + '<input type="button" value="Enviar">'
                        this.htmlToRender = this.htmlToRender + '</form>'
                        this.showButton = true
                        this.modalContainerVisible = true
                        this.actualCheck = entrada
                        this.$nextTick(() => {
                            var elementsForm = document.getElementsByClassName('customFormID')[0].elements
                            for (var i = 0; i < elementsForm.length; i++) {
                                if (this.caso.cf[elementsForm.item(i).name]) {
                                    elementsForm.item(i).value = this.caso.cf[elementsForm.item(i).name]
                                    const cfield = this.getCfield(elementsForm.item(i).name)  
                                    if (cfield) {
                                        elementsForm.item(i).required = cfield.required
                                        if (elementsForm.item(i).type === 'date') {
                                            elementsForm.item(i).value = new Date(this.caso.cf[elementsForm.item(i).name]).toISOString().slice(0, 10)
                                        }
                                    }
                                } else {
                                    const cfield = this.getCfield(elementsForm.item(i).name)  
                                    if (cfield) {
                                        elementsForm.item(i).required = cfield.required
                                    }
                                }
                            }
                        })
                    }
                    if (!entrada.objeto.estadocaso) {
                        this.check({ idcaso: entrada.idcaso, idtarea: entrada.objeto.id, value: entrada.value.target.checked, origin: window.location.hostname })
                    }
                    entrada.objeto.estadocaso = false
                // entrada.objeto.estadocaso = true
                }
        }
    },
    created() {
        this.getAll()
    },
}
</script>

<style>

</style>